import { render } from "./WpeInfo.vue?vue&type=template&id=078f0f40"
import script from "./WpeInfo.vue?vue&type=script&lang=js"
export * from "./WpeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "078f0f40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('078f0f40', __exports__)) {
    api.reload('078f0f40', __exports__)
  }
  
  module.hot.accept("./WpeInfo.vue?vue&type=template&id=078f0f40", () => {
    api.rerender('078f0f40', render)
  })

}


export default __exports__